module.exports = __webpack_public_path__ + "img/header.eb595222.png";